const API_BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const api = {
  login: `${API_BASE_URL}/api/login`,
  logout: `${API_BASE_URL}/api/logout`,
  assign:`${API_BASE_URL}/api/classes/assign`,
  descriptions:`${API_BASE_URL}/api/descriptions/assign`,
  register: `${API_BASE_URL}/api/register`,
};